<template>
  <HistoryTabTemplate
    :items="eventList"
    :loading="isLoading">
    <div>
      <div
        v-if="eventList.length > 0"
        class="overflow-auto height-100 flex flex-wrap flex-direction-column gap-4 mr-0">
        <div
          v-for="(event, index) in eventList"
          :key="index"
          class="pb-2"
          style="border-bottom: 1px solid var(--v-main__green-base);">
          <div class="text-left bold">
            {{ event.title }}
          </div>
          <div class="flex flex-between gap-2">
            <div>{{ $d(new Date(event.datetime), "shortDate") }} {{ $d(new Date(event.datetime), "time") }}</div>
            <StatusChip
              class="font-size-12 px-2 my-auto"
              :name="$t(`AutomationEventsStatus.${event.status}`)"
              :status="event.status"/>
          </div>
        </div>
      </div>
    </div>
    <MenuItem
      v-if="!isLoading && eventCount > eventList.length"
      key="footer"
      slot="footer"
      class="h11-links mx-auto mb-2"
      data-qa="item-automation-events"
      icon="circle-start"
      :label="$t('Menu.AutomationEvents')"
      small
      target="_blank"
      :to="{name: 'page-automation-events', query: {tenderId: tenderId, org: $route.params.org}}"/>
  </HistoryTabTemplate>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import HistoryTabTemplate from 'components/tenders/tender page/HistoryTabTemplate.vue'

import AutomationsApi from '@/api/automationsApi'
const automations_api = new AutomationsApi()

export default {
  name: 'tenderAutomationEvents',
  data() {
    return {
      isLoading: false,
      eventCount: 0,
      eventList: [],
    }
  },
  methods: {
    getAutomationEvents() {
      const data = {
        tenderId: this.tenderId,
        count: 15,
        page: 1,
      }
      this.isLoading = true
      automations_api.api_getAutomationLogs(data)
        .then(result => {
          this.eventCount = result?.totalCount ?? 0
          this.eventList = (result?.items ?? []).sort((a, b) => new Date(a.datetime) - new Date(b.datetime))
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  components: {
    MenuItem,
    StatusChip,
    HistoryTabTemplate
  },
  watch: {
    tenderId: {
      immediate: true,
      handler(newValue, oldValue) {
        if (!oldValue || newValue !== oldValue) {
          this.getAutomationEvents()
        }
      }
    }
  },
  props: {
    tenderId: {
      type: [String, Number],
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
}
</script>
<style scoped lang="scss">
</style>
